// extracted by mini-css-extract-plugin
module.exports = {"banner":"style_banner__1geKO","isCenter":"style_isCenter__vn1En","bannerInfoBox":"style_bannerInfoBox__igjOO","boxFrame":"style_boxFrame__3187c"};